var _rect, _g, _rect2, _rect3, _rect4, _rect5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 379,
    height: 240,
    viewBox: "0 0 379 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_298_8063",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 377,
    height: 238
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 377,
    height: 238,
    rx: 6,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_298_8063)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.404319,
    filter: "url(#filter0_f_298_8063)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -34.7168,
    y: -28.75,
    width: 498.037,
    height: 51.5667,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.156151,
    filter: "url(#filter1_f_298_8063)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95312 -10.9001L6.95312 256.85H-10.9048L-10.9048 -10.9001L6.95312 -10.9001Z",
    fill: "white"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 377,
    height: 238,
    rx: 6,
    fill: "white",
    fillOpacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    y: 0.625,
    width: 377.75,
    height: 238.75,
    rx: 6.375,
    fill: "white",
    fillOpacity: 0.05,
    stroke: "url(#paint0_linear_298_8063)",
    strokeWidth: 0.75
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 32.7461,
    y: 167.6,
    width: 186.516,
    height: 17.85,
    rx: 3,
    fill: "url(#paint1_linear_298_8063)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 30.7637,
    y: 36.7,
    width: 57.5421,
    height: 57.5167,
    rx: 3.6,
    fill: "#8A8A8B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_298_8063",
    x: -59.1813,
    y: -53.2145,
    width: 546.966,
    height: 100.496,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.2323,
    result: "effect1_foregroundBlur_298_8063"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_298_8063",
    x: -14.9817,
    y: -14.9776,
    width: 26.0123,
    height: 275.905,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.03871,
    result: "effect1_foregroundBlur_298_8063"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_298_8063",
    x1: 0.999996,
    y1: -30.0009,
    x2: -39.6973,
    y2: 217.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B8B8B",
    stopOpacity: 0.516361
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224563,
    stopColor: "#797979",
    stopOpacity: 0.463172
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#989898",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_298_8063",
    x1: 51.4075,
    y1: 184.557,
    x2: 219.262,
    y2: 184.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.a0bc48444abaeb4b0c5779710c80d29d.svg";
export { ForwardRef as ReactComponent };